<div class="upload-img-container">
  <div class="header">
    <h4>Upload Image</h4>
    <button class="close-button" (click)="closeModal()" [disabled]="aiGenerateModal">
      <img src="assets/icons/icon-close.svg" alt="" />
    </button>
  </div>
  <p class="aspect-ratio-info text-center">Ideal Aspect Ratio 2:3 (784 x 1164)</p>
  <div class="form-container">
    <div class="row" [formGroup]="playerdetailform">
      <div class="col-12">
        <!-- Your form content here -->
        <div class="image-upload-container d-flex align-items-start justify-content-center">
          <div class="inner-div-photo d-flex flex-column align-items-center justify-content-start">
            <div class="label-photo">MAP TOKEN</div>
            <div #croppieElement style="visibility: visible; height: auto; width: auto"></div>
          </div>
          <div class="inner-div-photo d-flex flex-column align-items-center justify-content-start">
            <div class="label-photo">PORTRAIT</div>
            <div class="img-full-character">
              @if (selectedImage) {
                <img [src]="selectedImage" class="preview-image"
                  alt="Selected Image" />
              }
            </div>
          </div>
          <input type="file" id="fileInput" accept="image/png,image/jpeg,image/gif"
            (change)="handleFileInput($event)" />
          </div>
          <div class="d-flex align-items-center justify-content-center">
            <label for="fileInput" class="choose-image-button">Choose Image</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12 btn-wrapper">
          <button type="button" class="btn btn-md btn-theme" (click)="closeModal()" [disabled]="aiGenerateModal">
            Cancel
          </button>
          <button type="button" class="upload-button btn btn-green" (click)="uploadImage()"
            [disabled]="!playerdetailform.valid">
            Upload
          </button>
        </div>
      </div>
    </div>
  </div>